import { createApp, h, computed, defineAsyncComponent } from 'vue';

import { createInertiaApp, usePage } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';

InertiaProgress.init();

createInertiaApp({
  resolve: name => import(`@/Pages/${name}`),
  setup({ el, App, props, plugin }) {
    if (process.env.NODE_ENV !== 'production') {
      console.log(props.initialPage);
    }

    const vueApp = createApp({ 
      render: () => h(App, props),
      setup() {
        const modalComponent = computed(() => usePage().props.value.modal
          ? defineAsyncComponent(() => import(`@/Pages/${usePage().props.value.modal.component}`))
          : null
        );

        return {modalComponent};
      } 
    });

    vueApp.mount(el);
  },
})